/**
 * クリニック向け Hub の権限判定（ユーザー管理・クリニック設定等で共通）
 */

export function canManageClinic(user) {
  const role = user?.role;
  return role === 'doctor' || role === 'admin';
}

export const HUB_CLINIC_EDIT_DENIED_MESSAGE =
  'クリニック情報の編集には医師または管理者権限が必要です。';

export const HUB_USER_MANAGE_DENIED_MESSAGE =
  'ユーザーの追加・管理には医師または管理者権限が必要です。';
